import { useApi } from '@hooks/useApi';
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@utils/consts';
import { BenchUser } from '@root/globalTypes';

type GetBenchUsersReturn = {
  data: BenchUser[];
  isPending: boolean;
};

export function useList(): GetBenchUsersReturn {
  const { query } = useApi();

  const { data, isPending } = useQuery<BenchUser[]>({
    queryKey: [...queryKeys.benchUsers, window.location.search],
    queryFn: (): Promise<BenchUser[]> =>
      query({
        path: `v1/staff/bench_users${window.location.search}`,
      }),
  });

  return {
    data: data || [],
    isPending,
  };
}
